module.exports = __webpack_public_path__ + "static/dotted-poland.4bef5e70.svg";